import React from 'react';

import { LegacyBox, LegacyText, Switch, MultiSelect } from '@gogame/components';

import BudgetGrid from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningForm/components/BudgetGrid';
import NodesBudget from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningForm/components/NodesBudget';
import BudgetSum from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/BudgetSum';
import { useSettings } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanSettings';
import { ValidationErrors } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/Validation';
import {
  RE,
  NETWORKS,
} from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

const TotalLevel = () => {
  const { meta, metricTypes, onChangeMetrics, onSwitchReBudget } =
    useSettings();

  const handleChangeMetrics = React.useCallback((_e, value) => {
    onChangeMetrics(value);
  }, []);

  const handleChangeReBudget = React.useCallback((e) => {
    onSwitchReBudget(e.target.checked);
  }, []);

  return (
    <React.Fragment>
      <LegacyBox gutter={32} align={'center'} style={{ padding: '16px' }}>
        <LegacyBox gutter={8} grow={1}>
          <BudgetSum minWidthValue={120} />
          <LegacyBox grow={1}>
            <LegacyText variant={'h6'}>Total Budget</LegacyText>
          </LegacyBox>
          <Switch
            label={'RE budget'}
            checked={meta.activityTypes.includes(RE)}
            onChange={handleChangeReBudget}
            style={{ flexDirection: 'row-reverse' }}
            data-cy-label={'reBudget'}
          />
        </LegacyBox>
        <MultiSelect
          value={meta.metricTypes}
          options={metricTypes}
          label={'KPIs'}
          width={'278px'}
          onChange={handleChangeMetrics}
          data-cy-label={'metricTypes'}
        />
      </LegacyBox>
      <BudgetGrid
        withBudgetPercent={false}
        withMetricApplyBelow={false}
        withAllocatedBudgetLeft={false}
        withAllocatedReBudgetLeft={false}
      />
      <ValidationErrors />
      <NodesBudget levelName={NETWORKS} withRemove={false} />
    </React.Fragment>
  );
};

export default TotalLevel;
